import { get, post } from '../tools/http';

export default {
    state: {
        mainInfo: [],
        bosses: [],
        documents: [],
        education: [],
        standarts: [],
        logistics: [],
        scholarship: [],
        paid: [],
        economic: [],
        vacancies: [],
        environment: [],
        cooperation: [],
        teachers: [],
    },
    mutations: {
        mainInfoSet: (state, value) => state.mainInfo = value,
        bossesSet: (state, value) => state.bosses = value,
        documentsSet: (state, value) => state.documents = value,
        educationSet: (state, value) => state.education = value,
        standartsSet: (state, value) => state.standarts = value,
        logisticsSet: (state, value) => state.logistics = value,
        scholarshipSet: (state, value) => state.scholarship = value,
        paidSet: (state, value) => state.paid = value,
        economicSet: (state, value) => state.economic = value,
        vacanciesSet: (state, value) => state.vacancies = value,
        environmentSet: (state, value) => state.environment = value,
        cooperationSet: (state, value) => state.cooperation = value,
        teachersSet: (state, value) => state.teachers = value,
        setDone: (state, value) => state.isDonon = value,
    },
    actions: {
        async loadPages(ctx) {
            const resp = await get (
                'cms',
                'entity/select/educationalOrganizationInfo',
                true
            );
            
            await resp.list.forEach(page => {
                
                page.content.forEach((content) => {
                    
                    content.files.forEach(file => {
                        file.type = file.url.split('.').pop();
                    });
                });

                ctx.commit(`${page.slug}Set`, page);
            });
        },
        async filterPages(ctx, text) {
            const promise = await get (
                'search',
                'search?q='+ text + '&filter[index][]=educational_organization_info',

            );
            return promise;
        },
    },
    getters: {
        getmainInfo: state => state.mainInfo,
        getBosses: state => state.bosses,
        getDocuments: state => state.documents,
        getEducation: state => state.education,
        getStandarts: state => state.standarts,
        getLogistics: state => state.logistics,
        getScholarship: state => state.scholarship,
        getPaid: state => state.paid,
        getEconomic: state => state.economic,
        getVacancies: state => state.vacancies,
        getEnvironment: state => state.environment,
        getCooperation: state => state.cooperation,
        getTeachers: state => state.teachers,
        getDonone: state => state.isDonon,
    },
};
